import { apiSlice } from './apiSlice';

const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.query({
      query: (_id) => `/users/${_id}`,
      providesTags: ['UserInfo'],
    }),

    getUserProfile: builder.query({
      query: (_id) => `/users/${_id}/profile`,
      providesTags: ['UserProfile'],
    }),

    followUser: builder.mutation({
      query: ({ id, userId }) => ({
        url: `/users/${id}/follow`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['UserProfile', 'UserInfo', 'CafeProfile', 'NoteDetail'],
    }),

    unfollowUser: builder.mutation({
      query: ({ id, userId }) => ({
        url: `/users/${id}/unfollow`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['UserProfile', 'UserInfo', 'CafeProfile', 'NoteDetail'],
    }),

    getFollowNote: builder.mutation({
      query: ({ id, noteNum, pageNum }) => ({
        url: `/users/${id}/followNote`,
        method: 'POST',
        body: {
          noteNum,
          pageNum,
        },
      }),
      invalidatesTags: ['NoteDetail'],
    }),

    resetPassword: builder.mutation({
      query: ({ id, password }) => ({
        url: `/users/${id}/reset`,
        method: 'PUT',
        body: {
          password,
        },
      }),
      invalidatesTags: ['UserProfile', 'UserInfo'],
    }),

    sendResetEmail: builder.mutation({
      query: ({ email }) => ({
        url: `/users/forget-password`,
        method: 'POST',
        body: {
          email,
        },
      }),
    }),

    emailResetPassword: builder.mutation({
      query: ({ id, token, password }) => ({
        url: `/users/reset-password/${id}/${token}/`,
        method: 'PUT',
        body: {
          password,
        },
      }),
      invalidatesTags: ['UserProfile', 'UserInfo'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserInfoQuery,
  useGetUserProfileQuery,
  useFollowUserMutation,
  useUnfollowUserMutation,
  useGetFollowNoteMutation,
  useResetPasswordMutation,
  useSendResetEmailMutation,
  useEmailResetPasswordMutation,
} = userApi;
